import { exportPdf } from "../service/exportService";

export const useExportarPDF = () => {
  const execute = (idCliente, tipoCliente, filtros) => {
    exportPdf(idCliente, tipoCliente, filtros);
  };

  return {
    execute,
  };
};
